export type Invoice = {
  id: string;
  name: string;
  userName: string;
  avatar: string;
  email: string;
  dueDate: string;
  amount: string;
  status: string;
  createdAt: Date;
};

export const invoiceData = [
  {
    id: '62447',
    name: 'Francis Sanford MD',
    userName: 'George33',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-01.webp',
    email: 'Maryam.Barrows@yahoo.com',
    dueDate: '2023-10-18T13:24:00.760Z',
    amount: '544.00',
    status: 'Paid',
    createdAt: '2023-01-14T20:37:08.482Z',
  },
  {
    id: '86740',
    name: 'Lucia Kshlerin',
    userName: 'Kenyon_Goldner56',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
    email: 'Mason_Davis4@yahoo.com',
    dueDate: '2023-07-18T01:06:16.095Z',
    amount: '560.00',
    status: 'Pending',
    createdAt: '2023-02-13T22:59:20.038Z',
  },
  {
    id: '42548',
    name: 'Byron Hoppe III',
    userName: 'Walton.Hane98',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
    email: 'Jayda_Schiller35@yahoo.com',
    dueDate: '2024-12-18T15:32:21.317Z',
    amount: '249.00',
    status: 'Pending',
    createdAt: '2022-11-30T06:51:47.972Z',
  },
  {
    id: '97024',
    name: 'Camille Jenkins',
    userName: 'Dalton_Von55',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-04.webp',
    email: 'Retha.Lehner47@hotmail.com',
    dueDate: '2024-06-30T19:06:03.018Z',
    amount: '255.00',
    status: 'Draft',
    createdAt: '2022-10-20T05:20:29.297Z',
  },
  {
    id: '14608',
    name: 'Kelli Mitchell',
    userName: 'Iva.Denesik',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-05.webp',
    email: 'Guiseppe.Champlin@hotmail.com',
    dueDate: '2025-07-24T18:45:02.179Z',
    amount: '329.00',
    status: 'Paid',
    createdAt: '2022-11-30T06:45:34.713Z',
  },
  {
    id: '95656',
    name: 'Randall Kuhic',
    userName: 'Henry_Quigley0',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-06.webp',
    email: 'Simeon93@yahoo.com',
    dueDate: '2023-11-02T00:20:47.253Z',
    amount: '402.00',
    status: 'Paid',
    createdAt: '2023-07-08T15:25:40.000Z',
  },
  {
    id: '73151',
    name: 'Jody Carroll',
    userName: 'Lavon32',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-07.webp',
    email: 'Frieda_Renner@gmail.com',
    dueDate: '2024-01-03T02:53:29.596Z',
    amount: '977.00',
    status: 'Overdue',
    createdAt: '2023-05-14T07:04:31.296Z',
  },
  {
    id: '57931',
    name: 'Jill Russel',
    userName: 'Abdiel.Terry',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-15.webp',
    email: 'Cleora.Murray@hotmail.com',
    dueDate: '2025-01-23T08:52:39.081Z',
    amount: '736.00',
    status: 'Paid',
    createdAt: '2023-07-13T13:18:55.586Z',
  },
  {
    id: '36515',
    name: 'Genevieve Hammes',
    userName: 'Kian_Huels',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-14.webp',
    email: 'Bernard63@yahoo.com',
    dueDate: '2024-07-29T18:18:19.193Z',
    amount: '755.00',
    status: 'Draft',
    createdAt: '2023-01-25T12:41:04.758Z',
  },
  {
    id: '34893',
    name: 'Alejandro Reichert',
    userName: 'Timothy91',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-13.webp',
    email: 'Wava.Muller47@gmail.com',
    dueDate: '2023-05-04T04:33:47.908Z',
    amount: '240.00',
    status: 'Draft',
    createdAt: '2022-10-10T12:07:33.682Z',
  },
  {
    id: '66356',
    name: 'Ricardo Kling',
    userName: 'Celia.Shanahan86',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-12.webp',
    email: 'Gene73@yahoo.com',
    dueDate: '2025-04-16T11:49:15.276Z',
    amount: '852.00',
    status: 'Overdue',
    createdAt: '2022-12-03T22:33:54.282Z',
  },
  {
    id: '81467',
    name: 'Carl Bode',
    userName: 'Pablo_Thompson',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-11.webp',
    email: 'Virgil.Skiles@hotmail.com',
    dueDate: '2024-05-28T04:44:49.629Z',
    amount: '295.00',
    status: 'Draft',
    createdAt: '2022-10-01T19:58:38.952Z',
  },
  {
    id: '14042',
    name: 'Sherry Weber',
    userName: 'Shane39',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-10.webp',
    email: 'Aidan22@hotmail.com',
    dueDate: '2025-11-30T00:34:34.822Z',
    amount: '318.00',
    status: 'Paid',
    createdAt: '2022-10-02T21:15:03.264Z',
  },
  {
    id: '49825',
    name: "Erika O'Reilly",
    userName: 'Hazle_Bednar95',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-07.webp',
    email: 'Ardith57@yahoo.com',
    dueDate: '2024-05-17T06:24:33.253Z',
    amount: '463.00',
    status: 'Overdue',
    createdAt: '2023-08-07T21:46:55.537Z',
  },
  {
    id: '81929',
    name: 'Lillian Anderson',
    userName: 'Cyrus_Hettinger',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-02.webp',
    email: 'Aletha_Waters87@gmail.com',
    dueDate: '2023-12-29T04:41:54.007Z',
    amount: '196.00',
    status: 'Pending',
    createdAt: '2022-12-05T08:16:30.407Z',
  },
  {
    id: '25086',
    name: 'Connie Braun',
    userName: 'Ramona99',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-14.webp',
    email: 'Mervin.Rutherford@hotmail.com',
    dueDate: '2024-12-27T21:39:17.142Z',
    amount: '384.00',
    status: 'Draft',
    createdAt: '2023-07-03T16:12:56.039Z',
  },
  {
    id: '79737',
    name: 'Mattie Miller',
    userName: 'Madison_MacGyver-Lesch52',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-03.webp',
    email: 'Bianka30@yahoo.com',
    dueDate: '2025-06-27T15:53:33.802Z',
    amount: '812.00',
    status: 'Paid',
    createdAt: '2022-09-17T03:52:26.870Z',
  },
  {
    id: '66747',
    name: 'Shelley Lind-VonRueden',
    userName: 'Issac_West',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-08.webp',
    email: 'Destini_Williamson34@yahoo.com',
    dueDate: '2024-12-29T09:04:48.858Z',
    amount: '596.00',
    status: 'Pending',
    createdAt: '2023-02-27T21:17:07.214Z',
  },
  {
    id: '44937',
    name: 'Manuel Langworth',
    userName: 'Kelley71',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-06.webp',
    email: 'Philip.OKeefe94@gmail.com',
    dueDate: '2025-12-20T09:41:31.402Z',
    amount: '545.00',
    status: 'Pending',
    createdAt: '2022-11-02T22:49:45.640Z',
  },
  {
    id: '11420',
    name: 'Dr. Guillermo Huels Jr.',
    userName: 'Linnie.Hane',
    avatar:
      'https://isomorphic-furyroad.s3.amazonaws.com/public/avatars-blur/avatar-11.webp',
    email: 'Ricky41@yahoo.com',
    dueDate: '2023-03-26T14:06:10.093Z',
    amount: '537.00',
    status: 'Paid',
    createdAt: '2023-01-19T08:56:14.820Z',
  },
];
